import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useResponsive } from '../hooks/useResponsive';
import comment2 from '../comment2.png';
import comment3 from '../comment3.png';
import comment4 from '../comment4.png';
import comment5 from '../comment5.png';
import {
    FaUser, FaShieldAlt, FaUsers, FaUserEdit, FaSearch
} from 'react-icons/fa';
import { BsHeart, BsBook } from "react-icons/bs";
import { GrShield } from "react-icons/gr";
import { RiChatHeartLine } from "react-icons/ri";
import { GoVerified } from "react-icons/go";

import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';
const Comment = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { isSmall: isSmallMobile, isMobile, isTablet } = useResponsive();

    return (
        <div style={styles.container}>

            {/* ═══════════════ NAVBAR ═══════════════ */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* ═══════════════ HERO ═══════════════ */}
            <section style={{
                position: 'relative',
                overflow: 'hidden',
                minHeight: isSmallMobile ? '280px' : isMobile ? '320px' : isTablet ? '360px' : '460px',
                backgroundColor: '#fdf3f7',
            }}>
                {!isMobile && (
                    <img src={comment2} alt="" style={{
                        position: 'absolute',
                        top: 0, right: 0,
                        width: '100%', height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                    }} />
                )}
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: isMobile ? '100%' : isTablet ? '60%' : '52%',
                    padding: isSmallMobile ? '32px 16px' : isMobile ? '48px 24px' : isTablet ? '48px 40px' : '80px 64px',
                    display: 'flex', flexDirection: 'column',
                    alignItems: isMobile ? 'center' : 'flex-start',
                    textAlign: isMobile ? 'center' : 'left',
                }}>
                    <p style={{ color: '#781840', fontSize: isSmallMobile ? '10px' : '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px', marginTop: 0 }}>
                        ÉTAPES SIMPLES, VALEURS FORTES
                    </p>
                    <h1 style={{ color: '#1a0010', fontWeight: '700', fontSize: isSmallMobile ? '26px' : isMobile ? '32px' : isTablet ? '38px' : '46px', lineHeight: '1.2', marginBottom: '16px', marginTop: 0 }}>
                        Comment <span style={{ color: '#c0306a' }}>ça marche</span> ?
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '24px' }}>
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                        <div style={{ width: '32px', height: '2px', backgroundColor: '#781840' }} />
                    </div>
                    <p style={{ color: '#555', lineHeight: '1.8', fontSize: isSmallMobile ? '13px' : '14px', margin: 0, maxWidth: isMobile ? '100%' : '420px' }}>
                        Zawaj & Tawadud a été conçu pour vous guider pas à pas dans votre recherche d'une union bénie, en toute simplicité, sécurité et sérénité.
                    </p>
                </div>
            </section>

            {/* ═══════════════ PARCOURS 4 ÉTAPES ═══════════════ */}
            <section style={{ backgroundColor: '#fff', padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 20px' : isTablet ? '48px 24px' : '64px 24px', textAlign: 'center' }}>
                <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '20px' : isMobile ? '24px' : isTablet ? '28px' : '32px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>
                    Un parcours simple et sécurisé
                </h2>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: isSmallMobile ? '32px' : '48px' }}>
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                    maxWidth: isTablet ? '100%' : '1000px',
                    margin: '0 auto',
                    gap: isMobile ? '32px 16px' : isTablet ? '0 8px' : '0',
                    position: 'relative',
                    padding: isTablet ? '0 16px' : '0',
                }}>
                    {[
                        { icon: <FaUserEdit size={isMobile ? 22 : 28} color="#781840" />, num: '1', title: 'Inscription', text: 'Créez votre compte en quelques minutes et sécurisez votre profil.' },
                        { icon: <FaUser size={isMobile ? 22 : 28} color="#781840" />, num: '2', title: 'Complétez votre profil', text: 'Renseignez vos informations, vos valeurs et vos objectifs de mariage.' },
                        { icon: <FaSearch size={isMobile ? 22 : 28} color="#781840" />, num: '3', title: 'Découvrez des profils', text: 'Trouvez des profils compatibles selon vos critères et vos préférences.' },
                        { icon: <RiChatHeartLine size={isMobile ? 22 : 28} color="#781840" />, num: '4', title: 'Entamez une relation sérieuse', text: "Échangez dans le respect et avec l'intention du mariage, en toute sécurité." },
                    ].map((step, i) => (
                        <div key={i} style={{ position: 'relative', padding: '0 8px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {!isMobile && i < 3 && (
                                <div style={{
                                    position: 'absolute',
                                    top: isTablet ? '40px' : '50px',
                                    left: 'calc(50% + 45px)',
                                    width: 'calc(100% - 90px)',
                                    borderTop: '2px dashed #e3a9c4',
                                    zIndex: 0,
                                }} />
                            )}
                            <div style={{
                                position: 'relative',
                                width: isSmallMobile ? '76px' : isMobile ? '88px' : isTablet ? '80px' : '100px',
                                height: isSmallMobile ? '76px' : isMobile ? '88px' : isTablet ? '80px' : '100px',
                                borderRadius: '50%',
                                backgroundColor: '#fff',
                                border: '1px solid #f0dde6',
                                boxShadow: '0 4px 20px rgba(192,48,106,0.12)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                marginBottom: '20px',
                                zIndex: 1,
                            }}>
                                {step.icon}
                                <div style={{
                                    position: 'absolute', bottom: '-10px',
                                    width: '24px', height: '24px',
                                    borderRadius: '50%',
                                    backgroundColor: '#c0306a',
                                    color: 'white',
                                    fontSize: '12px', fontWeight: '700',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    border: '2px solid #fff',
                                }}>{step.num}</div>
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: isSmallMobile ? '12px' : isTablet ? '13px' : '15px', fontWeight: '700', marginBottom: '8px', marginTop: 0 }}>{step.title}</h4>
                            <p style={{ color: '#888', fontSize: isSmallMobile ? '11px' : '12px', lineHeight: '1.7', margin: 0, maxWidth: isTablet ? '150px' : '180px' }}>{step.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════════ ACCOMPAGNEMENT ═══════════════ */}
            <section style={{
                backgroundImage: `url(${comment3})`,
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                margin: isSmallMobile ? '0 8px' : isMobile ? '0 12px' : isTablet ? '0 16px' : '0 24px',
                borderRadius: '20px',
                padding: isSmallMobile ? '32px 12px' : isMobile ? '40px 16px' : isTablet ? '48px 24px' : '56px 32px',
            }}>
                <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '18px' : isMobile ? '22px' : isTablet ? '26px' : '30px', fontWeight: '700', marginBottom: '10px', marginTop: 0, textAlign: 'center' }}>
                    Chaque étape, un accompagnement bienveillant
                </h2>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: isSmallMobile ? '24px' : '40px' }}>
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840', transform: 'rotate(45deg)' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isSmallMobile ? '1fr' : isMobile ? '1fr 1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    maxWidth: '1100px',
                    margin: '0 auto',
                    gap: isSmallMobile ? '12px' : '16px',
                }}>
                    {[
                        { icon: <GrShield size={isMobile ? 20 : 24} color="white" />, title: 'Sécurité avant tout', text: 'Vos données sont protégées et jamais partagées.' },
                        { icon: <GoVerified size={isMobile ? 20 : 24} color="white" />, title: 'Modération humaine', text: 'Chaque profil est vérifié pour garantir un environnement sain et respectueux.' },
                        { icon: <BsHeart size={isMobile ? 20 : 24} color="white" />, title: 'Conseils et ressources', text: 'Accédez à des articles, rappels et conseils pour vous guider vers une union réussie.' },
                        { icon: <FaUsers size={isMobile ? 20 : 24} color="white" />, title: 'Soutien à chaque étape', text: 'Notre équipe est disponible pour vous accompagner avec écoute et bienveillance.' },
                    ].map((c, i) => (
                        <div key={i} style={{
                            backgroundColor: 'white', borderRadius: '16px',
                            padding: isSmallMobile ? '20px 14px' : isMobile ? '24px 16px' : '32px 20px',
                            border: '1px solid #f0dde6',
                            boxShadow: '0 2px 14px rgba(192,48,106,0.06)',
                            textAlign: 'center',
                        }}>
                            <div style={{ width: isSmallMobile ? '44px' : '54px', height: isSmallMobile ? '44px' : '54px', borderRadius: '50%', backgroundColor: '#a01850', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                                {c.icon}
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: isSmallMobile ? '13px' : '14px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>{c.title}</h4>
                            <p style={{ color: '#999', fontSize: isSmallMobile ? '11px' : '12px', lineHeight: '1.7', margin: 0 }}>{c.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════════ NOS ENGAGEMENTS ═══════════════ */}
            <section style={{ padding: isSmallMobile ? '24px 8px' : isMobile ? '32px 12px' : isTablet ? '40px 16px' : '48px 24px' }}>
                <div style={{
                    maxWidth: '2400px',
                    margin: '0 auto',
                    backgroundColor: '#4a0028',
                    backgroundImage: `url(${comment4})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '20px',
                    padding: isSmallMobile ? '28px 16px' : isMobile ? '32px 20px' : isTablet ? '40px 32px' : '60px 0px 40px 0px',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '24px' : '0px',
                    alignItems: 'center',
                    minHeight: isMobile ? 'auto' : '160px',
                    overflow: 'hidden',
                }}>
                    {!isMobile && (
                        <div style={{ flex: `0 0 ${isTablet ? '80px' : '160px'}`, minWidth: isTablet ? '80px' : '100px', alignSelf: 'stretch' }} />
                    )}
                    <div style={{
                        flex: '0 0 auto',
                        maxWidth: isMobile ? '100%' : isTablet ? '180px' : '220px',
                        textAlign: isMobile ? 'center' : 'left',
                        padding: isMobile ? '0' : '0 0 0 8px',
                    }}>
                        <h2 style={{ color: 'white', fontSize: isSmallMobile ? '18px' : isMobile ? '20px' : isTablet ? '18px' : '22px', fontWeight: '700', lineHeight: '1.35', marginBottom: '12px', marginTop: 0 }}>
                            Nos engagements<br />pour votre sérénité
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.50)', fontSize: isSmallMobile ? '11px' : '12px', lineHeight: '1.8', margin: 0 }}>
                            Nous mettons tout en œuvre pour vous offrir une expérience basée sur l'éthique islamique et les valeurs de respect et de sincérité.
                        </p>
                    </div>
                    {!isMobile && (
                        <div style={{ width: '1px', height: '100px', backgroundColor: 'rgba(255,255,255,0.15)', flexShrink: 0, alignSelf: 'center', margin: isTablet ? '0 20px' : '0 40px' }} />
                    )}
                    <div style={{
                        flex: 1,
                        display: 'grid',
                        gridTemplateColumns: isSmallMobile ? '1fr 1fr' : isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                        gap: isMobile ? '20px 12px' : isTablet ? '0 4px' : '0 8px',
                        padding: isMobile ? '0' : isTablet ? '0 16px 0 0' : '0 40px 0 0',
                    }}>
                        {[
                            { icon: <FaShieldAlt size={isMobile ? 20 : 24} color="white" />, title: 'Respect de la vie privée' },
                            { icon: <FaUsers size={isMobile ? 20 : 24} color="white" />, title: 'Zéro tolérance aux comportements inappropriés' },
                            { icon: <RiChatHeartLine size={isMobile ? 20 : 24} color="white" />, title: 'Modération humaine et bienveillante' },
                            { icon: <BsBook size={isMobile ? 20 : 24} color="white" />, title: "Conforme à l'éthique islamique" },
                        ].map((e, i) => (
                            <div key={i} style={{
                                display: 'flex', flexDirection: 'column',
                                alignItems: 'center', textAlign: 'center',
                                gap: isMobile ? '10px' : '16px',
                                padding: '0 4px',
                                borderRight: (!isMobile && i < 3) ? '1px solid rgba(255,255,255,0.15)' : 'none',
                            }}>
                                <div style={{
                                    width: isSmallMobile ? '52px' : isMobile ? '58px' : isTablet ? '56px' : '68px',
                                    height: isSmallMobile ? '52px' : isMobile ? '58px' : isTablet ? '56px' : '68px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(255,255,255,0.13)',
                                    border: '1.5px solid rgba(255,255,255,0.22)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    {e.icon}
                                </div>
                                <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: isSmallMobile ? '10px' : isTablet ? '11px' : '12.5px', lineHeight: '1.6', margin: 0, fontWeight: '500', maxWidth: isTablet ? '110px' : '140px' }}>
                                    {e.title}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════════ CTA ═══════════════ */}
            <section style={{
                margin: isSmallMobile ? '0 8px 20px' : isMobile ? '0 12px 24px' : isTablet ? '0 16px 24px' : '0 24px 32px',
                borderRadius: '20px', overflow: 'hidden', position: 'relative',
                backgroundImage: `url(${comment5})`,
                backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',
                backgroundColor: '#fdf3f7',
            }}>
                <div style={{
                    position: 'relative', zIndex: 2,
                    display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '24px' : isTablet ? '32px' : '48px',
                    maxWidth: isTablet ? '90%' : '700px',
                    margin: '0 auto',
                    padding: isSmallMobile ? '32px 16px' : isMobile ? '48px 20px' : isTablet ? '48px 32px' : '60px 40px',
                    alignItems: 'center',
                }}>
                    <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
                        <h2 style={{ color: '#1a0010', fontSize: isSmallMobile ? '18px' : isMobile ? '22px' : isTablet ? '24px' : '30px', fontWeight: '700', lineHeight: '1.4', marginBottom: '12px', marginTop: 0 }}>
                            Prêt à faire le premier pas vers une <span style={{ color: '#c0306a' }}>union bénie</span> ?
                        </h2>
                        <p style={{ color: '#444', fontSize: isSmallMobile ? '13px' : '14px', lineHeight: '1.8', margin: 0 }}>
                            Rejoignez une communauté sérieuse et faites le choix d'une démarche sincère et éthique.
                        </p>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : 'flex-start', gap: '16px', flexShrink: 0 }}>
                        <button onClick={() => navigate('/register')} style={{ padding: isSmallMobile ? '12px 14px' : '14px 18px', backgroundColor: '#3d0a20', color: 'white', border: '0.5px solid #8a1e4e', borderRadius: '8px', fontSize: isSmallMobile ? '13px' : '14px', cursor: 'pointer', fontWeight: '400', display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                            <FaUser size={13} /> Créer un compte gratuitement
                        </button>
                        <p style={{ color: '#444', fontSize: '13px', margin: 0 }}>
                            Déjà membre ?{' '}
                            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{ color: '#3d0a20', textDecoration: 'underline', fontWeight: '600', cursor: 'pointer' }}>
                                Se connecter
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            {/* ═══════════════ FOOTER ═══════════════ */}
            <Footer />

        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial, sans-serif', overflowX: 'hidden' },
};

export default Comment;
